import { render, staticRenderFns } from "./imgLink.vue?vue&type=template&id=6071b5ea&scoped=true&"
import script from "./imgLink.vue?vue&type=script&lang=js&"
export * from "./imgLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071b5ea",
  null
  
)

export default component.exports